(function() {
  'use strict';

  var SELECTOR = 'catalogue-carousel';

  function defineCarousel() {
    if (customElements.get('catalogue-carousel')) return;

    customElements.define('catalogue-carousel', class CatalogueCarousel extends HTMLElement {
      constructor() {
        super();
        this.index = 0;
        this.touchStartX = 0;
      }

      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        this.onPrev = this.goToPrevious.bind(this);
        this.onNext = this.goToNext.bind(this);
        this.onTouchStart = this.handleTouchStart.bind(this);
        this.onTouchEnd = this.handleTouchEnd.bind(this);

        if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });

        this.update();
      }

      disconnectedCallback() {
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
      }

      goToPrevious() {
        this.goTo(this.index - 1);
      }

      goToNext() {
        this.goTo(this.index + 1);
      }

      goTo(nextIndex) {
        if (!this.track) this.track = this.querySelector('[data-carousel-track]');
        if (this.track) {
          this.slides = Array.prototype.slice.call(
            this.track.querySelectorAll('[data-carousel-slide]')
          );
        }
        var maxIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.index = Math.max(0, Math.min(nextIndex, maxIndex));
        this.update();
      }

      update() {
        if (!this.track) this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;

        this.slides = Array.prototype.slice.call(
          this.track.querySelectorAll('[data-carousel-slide]')
        );
        if (!this.slides.length) return;

        var maxIndex = this.slides.length - 1;
        if (this.index > maxIndex) this.index = maxIndex;
        if (this.index < 0) this.index = 0;

        var offset = this.index * -100;
        this.track.style.transform = 'translateX(' + offset + '%)';

        var hasMultipleSlides = this.slides.length > 1;
        if (this.prevButton) {
          this.prevButton.hidden = !hasMultipleSlides;
          this.prevButton.disabled = this.index === 0;
        }
        if (this.nextButton) {
          this.nextButton.hidden = !hasMultipleSlides;
          this.nextButton.disabled = this.index === this.slides.length - 1;
        }
      }

      handleTouchStart(event) {
        if (!event.changedTouches.length) return;
        this.touchStartX = event.changedTouches[0].clientX;
      }

      handleTouchEnd(event) {
        if (!event.changedTouches.length) return;
        var diff = this.touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        if (diff > 0) {
          this.goToNext();
        } else {
          this.goToPrevious();
        }
      }
    });
  }

  function refreshCarousels(root) {
    defineCarousel();
    (root || document).querySelectorAll(SELECTOR).forEach(function(carousel) {
      if (typeof carousel.update === 'function') carousel.update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      refreshCarousels(document);
    });
  } else {
    refreshCarousels(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    refreshCarousels(event.target);
  });

  document.addEventListener('shopify:section:reorder', function(event) {
    refreshCarousels(event.target);
  });
})();
